import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { Button } from 'components';

import style from './JoinUsBanner.module.scss';

const JoinUsBanner = ({ light = false }) => {
  const { t } = useTranslation('page');
  const containerRef = useRef();

  useEffect(() => {
    document.addEventListener('scroll', () => {
      const scrolled = window.scrollY;

      if (containerRef.current?.style?.backgroundPosition) {
        containerRef.current.style.backgroundPosition = 'top ' + scrolled * 0.1 + 'px';
      }
    });
  }, []);

  return (
    <div
      className={cn(style.container, { [style.light]: light })}
      ref={containerRef}
    >
      <h3 className={style.text}>
        {t('home.joinUsBanner.text1')} <br />
        {t('home.joinUsBanner.text2')}
      </h3>
      <Button
        label={t('common:navigation.scheduleDemo')}
        to={'/contact'}
      />
    </div>
  );
};

export default JoinUsBanner;
